import { T }         from 'defa-object';
import ControlModule from 'scripts/poppet/control-module';
import template      from './controlFollowMainAlarm.jst.html';
import { Vue }       from 'vue/defavue';

const actionOptions     = [
	{ value: 'ON', 	title: T.tc( 'GeneralAlarmInput', 'On' ), 	titleContext: 'GeneralAlarmInput' },
	{ value: 'OFF', title: T.tc('GeneralAlarmInput', 'Off' ),	titleContext: 'GeneralAlarmInput' }
];

export const ControlFollowMainAlarmView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	
	className: function () {
		return this._getClassName( 'control-general-alarm-input' );
	},
	
	onDomRefresh() {
		let self   = this;
		
		let followMainAlarmSlider = new Vue ({
			el: '#followMainAlarm-slider',
			
			bb() {
				return {
					model: self.model,
				};
			},
			
			data() {
				return {
					followMainAlarmSwitchValue: 'ON',
					actionOptions,
				}
			},
			methods : {
				save(newValue, attributeName) {
					let data = {};
					data[attributeName]= 'ON' === newValue;
					self.save( data )
				},
			},
			
			computed: {
				followMainAlarmSwitchDisabled: function () {
					return null === this.model.followMainIntrusionAlarmSwitch
				}
			},
			
			watch: {
				'model.followMainIntrusionAlarmSwitch': function (newAttribute){
					this.followMainAlarmSwitchValue = newAttribute ? 'ON' : 'OFF';
				}
			},
			
			created() {
				this.followMainAlarmSwitchValue = this.model.followMainIntrusionAlarmSwitch ? 'ON' : 'OFF';
			}
		});
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	save: function(attributes) {
		this.model.set('isValidData', false);
		try {
			this.model.save(attributes, {
				isSaving: true,
				patch: true,
				success: function () {
					console.log( Object.keys(attributes)[0] +' was succesfully saved!' );
				},
				error  : function (model, response) {
					console.error( Object.keys(attributes)[0] + ' failed saving with error: ' + response.responseJSON.message );
				}
			});
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	}
});

export default  ControlFollowMainAlarmView;
